export default { sha: '53a3d43ede0436603228de7c4fb456dc6e20896d', buildNumber: 'undefined' }
